var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesktopIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Desktop",
    d: "M352.57,463.93l-191.47.11c-4.33,0-8.95-2.44-8.94-7.11l.09-26.21c.01-4.3,4.46-6.75,8.19-6.74l33.03.03.9-5.18,3.76-18.82-164.87-.05c-13.57-1.7-23.46-11.65-25.25-25.15l.02-302.04c2.01-12.91,11.41-22.36,24.24-24.75h447.04c13.4,2.12,23.56,12.54,24.69,26.06l-.03,301.14c-2.16,13.33-11.81,23-25.26,24.73l-164.89.06,4.63,23.99h33.58c4.02.19,7.89,3.26,7.87,7.5l-.07,25.53c0,3.12-3.39,6.9-7.27,6.9ZM487.95,75.59c0-6.14-4.91-10.41-10.69-11.56H35.63c-5.98.43-10.03,4.44-11.6,10.21v261.73s463.97-.04,463.97-.04l-.05-260.33ZM297.63,400.01l-83.31.03-4.47,24,92.35-.09-4.58-23.93ZM167.99,440.02v8s176.02-.02,176.02-.02v-8s-176.02.02-176.02.02ZM488.02,373l-.08-20.98H24.07s-.07,21.13-.07,21.13c.67,4.79,4.84,10.81,10.6,10.81l442.92.06c5.94-1.11,9.85-5.46,10.5-11.02ZM272,367.31c-.38-4.08-3.61-7.33-7.98-7.33h-16.04c-3.22,0-6.17,2.15-7.24,4.59-1.38,3.14-.95,6.38,1.29,9.04,1.14,1.36,3.55,2.34,5.53,2.33l17.59-.14c4.61-.04,7.21-4.69,6.86-8.49Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopIcon);
export default __webpack_public_path__ + "static/media/desktopIcon.f83c00ed98ff48d557f1a74ca138b8bf.svg";
export { ForwardRef as ReactComponent };